export default __webpack_public_path__ + "d419d5910b7691d651463997e86ad29e.svg";